export enum Slugs {
  NEWS = "news",
  ARTICLE = "article",
}
